import { render, staticRenderFns } from "./ReviewPrimehill.vue?vue&type=template&id=e081ddca&scoped=true&"
import script from "./ReviewPrimehill.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ReviewPrimehill.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ReviewPrimehill.vue?vue&type=style&index=0&id=e081ddca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e081ddca",
  null
  
)

export default component.exports